'use strict';
const angular = require('angular');

export class tabsWidgetComponent {

  constructor(SettingsService, DynamicPageService) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.DynamicPageService = DynamicPageService;
  }

  $onInit() {

    this.justified = this.justified == 'true';
    this.type = this.type == 'pills' ? 'pills' : 'tabs';
    this.vertical = this.vertical == 'true';

    let FN = (this.public) ? "getPublicByName" : "getByName";

    this.SettingsService[FN]({name: this.settings}, setting => {
      let tabs = setting.data;

      tabs.forEach(tab => {
        if (!tab.content) {
          this.DynamicPageService.getByName({name: tab.page}, page => {
            tab.content = this.convertShortcode(page.data);
          })
        } else {
          tab.content = this.convertShortcode(tab.content);
        }
      });

      this.tabs = tabs;

    }, err => {
      console.log('could not retrieve setting');
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduuApp.tabsWidget', [])
  .component('tabsWidget', {
    template: require('./tabs-widget.component.html'),
    bindings: {
      public: '@',
      settings: '@',
      justified: '@',
      vertical: '@',
      type: '@'
    },
    controller: tabsWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/tabs-widget/tabs-widget.component.js